export default function SessionService(ipCookie) {
        'ngInject';

        this.token = null;
        this.refreshToken = null;
        this.readOnlyMode = null;

        this.create = function(token, refreshToken) {
            this.setSessionItem('token', token);
            this.setSessionItem('refreshToken', refreshToken);
        };

        this.destroy = function() {
            this.clearSessionItem('token');
            this.clearSessionItem('refreshToken');
            this.clearSessionItem('availableServices');
        };

        this.hasLocalSession = function() {
            return !!(this.token || this.refreshToken);
        };

        this.hasStorageSession = function() {
            return !!(this.getStorageItem('token') || this.getStorageItem('refreshToken'));
        };

        this.setSessionItem = function(key, value) {
            this.setStorageItem(key, angular.copy(value));
            this[key] = angular.copy(value);
        };

        this.getSessionItem = function(key) {
            if (this[key]) {
                return angular.copy(this[key]);
            }
            if (this.getStorageItem(key)) {
                return angular.copy(this.getStorageItem(key));
            }
            return null;
        };

        this.clearSessionItem = function(key) {
            this.clearStorageItem(key);
            this[key] = null;
        };

        this.setStorageItem = function(key, value) {
            ipCookie(key, angular.copy(value), {path: '/', secure: process.env.COOKIES_SECURE, sameSite: 'none'});
        };

        this.getStorageItem = function(key) {
            return angular.copy(ipCookie(key));
        };

        this.clearStorageItem = function(key) {
            ipCookie.remove(key);
        };
}



// WEBPACK FOOTER //
// ./src/app/services/sessionService.js